import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskProformaIssueFormsDirectRoute: InvariantJiraRoute = {
	name: 'servicedesk-proforma-issue-forms-direct',
	path: '/jira/servicedesk/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
	exact: true,
};
